module.exports = __webpack_public_path__ + "static/media/snowLogo.de9f725c.svg";